import styled from 'styled-components';

export const Styled = styled.span`
  font-size: 16px;
  line-height: 26px;
  font-weight: 400;
  color: #2d3540;

  b {
    font-weight: 700;
  }
`;
